<template>
    <a v-if="external" :href="href" target="_blank" rel="noopener noreferrer"
        ><slot /><IconExternalLink
            v-if="icon"
            class="icon-external-link"
            :width="iconSize"
            :height="iconSize"
            aria-hidden="true"
            focusable="false"
        /><span class="visuallyhidden"> {{ t('a11y.external_link') }}</span></a
    >
    <a v-else :href="href"><slot /></a>
</template>

<script setup>
// Twig equivalent: templates/components/external-link-indicator.html.twig
import { useI18n } from 'vue-i18n';
import IconExternalLink from '@@/icons/external-link.svg';

defineProps({
    href: {
        type: String,
        default: '',
    },
    // Opens in a new tab and adds the screen reader notice.
    external: {
        type: Boolean,
        default: false,
    },
    // FALSE to only add the screen reader notice (no visible icon).
    icon: {
        type: Boolean,
        default: true,
    },
    // 12 in text links, 14 in buttons.
    iconSize: {
        type: [Number, String],
        default: 12,
    },
});

const { t } = useI18n();
</script>
